import React, { useMemo } from "react";

import { ChartData, Cartesian } from "@examspark/types";

import CartesianGrid from "../graph/cartesian/CartesianGrid";
import { Text } from "../graph/cartesian/Text";
import {
  getImageCoordsFromCartesianCoords,
  getTickIntegers,
} from "../graph/cartesian/utils";
import Graph from "../graph/Graph";

interface Props {
  graph: Cartesian.Graph;
  data: ChartData;
  onChange?: (data: ChartData) => void;
}

const BasicChart: React.FC<React.PropsWithChildren<Props>> = ({
  data,
  onChange,
  ...props
}) => {
  const ticks = useMemo(() => {
    return {
      x: getTickIntegers(props.graph.x),
      y: getTickIntegers(props.graph.y),
    };
  }, [props]);

  return (
    <Graph {...props.graph}>
      <CartesianGrid graph={props.graph} />
      {ticks.y.map((int) => {
        return (
          <Text
            key={int}
            coords={getImageCoordsFromCartesianCoords(
              props.graph,
              { x: 0, y: int },
              { x: -10, y: 4 },
            )}
          >
            {int}
          </Text>
        );
      })}
      {props.graph.title && (
        <Text coords={{ x: props.graph.width / 2, y: 20 }} anchor="middle">
          {props.graph.title}
        </Text>
      )}
      {!!props.graph.x.label && (
        <text
          textAnchor="middle"
          x={props.graph.width / 2}
          y={props.graph.height - 20}
        >
          {props.graph.x.label}
        </text>
      )}
      {!!props.graph.y.label && (
        <text
          x={20}
          y={props.graph.height / 2}
          textAnchor="middle"
          transform={`rotate(-90, 20, ${props.graph.height / 2})`}
        >
          {props.graph.y.label}
        </text>
      )}
      {props.children}
    </Graph>
  );
};

export default BasicChart;
